import {
  CREATE_TASTING_REMOVE_DESCRIPTION,
  CREATE_TASTING_SET_DESCRIPTIONS,
  CREATE_TASTING_SELECT_LANG,
  CREATE_TASTING_SET_LANG,
  CREATE_SELECT_TYPE,
  CREATE_TASTING_SET_CODE,
  ERROR,
  CREATE_TASTING_SET_FILE,
  CREATE_TASTING_REMOVE_FILE,
  CREATE_TASTING_SET_VISIT,
  CREATE_TASTING_SET_STORE,
  CREATE_TASTING_SET_IMAGE,
  CREATE_TASTING_SET_ID_VIDEOS,
  CREATE_TASTING_SET_TITLE1,
  CREATE_TASTING_SET_TITLE2,
  CREATE_TASTING_REMOVE_IMAGE,
  CREATE_TASTING_VIDEO_CHECK,
  CREATE_TASTING_BROCHURE_CHECK,
  CREATE_TASTING_SET_BROCHURE,
  CREATE_TASTING_REMOVE_BROCHURE,
  CREATE_TASTING_SET_TITLE1B,
  CREATE_TASTING_SET_TITLE2B,
  CREATE_TASTING_RESET,
  CREATE_TASTING_SET_IMAGEBROCHURE,
  CREATE_TASTING_REMOVE_IMAGEBROCHURE,
} from "../constant/types";

const initialState = {
  lang: [],
  selectLang: null,
  types: ["tourism", "special", "event"],
  selectType: null,
  code: "",
  details: "",
  visit: "",
  store: "",
  file: null,

  brochure: "",
  brochureCheck: false,
  imageBrochure: null,
  title1b: "",
  title2b: "",

  title1: "",
  title2: "",
  image: null,
  videoCheck: false,
  id_youtube: "",
};

export default function createTasting(state = initialState, action) {
  switch (action.type) {
    case CREATE_TASTING_SET_LANG:
      return {
        ...state,
        lang: action.payload,
      };
    case CREATE_TASTING_SELECT_LANG:
      return {
        ...state,
        selectLang: state.lang.find((elem) => elem.code === action.payload),
      };
    case CREATE_SELECT_TYPE:
      return {
        ...state,
        selectType: action.payload,
      };

    case CREATE_TASTING_SET_CODE:
      return {
        ...state,
        code: action.payload,
      };
    case CREATE_TASTING_SET_DESCRIPTIONS:
      return {
        ...state,
        details: action.payload,
      };
    case CREATE_TASTING_SET_VISIT:
      return {
        ...state,
        visit: action.payload,
      };
    case CREATE_TASTING_SET_STORE:
      return {
        ...state,
        store: action.payload,
      };
    case CREATE_TASTING_REMOVE_DESCRIPTION:
      return {
        ...state,
        details: action.payload,
      };

    case CREATE_TASTING_SET_FILE:
      return {
        ...state,
        file: action.payload,
      };
    case CREATE_TASTING_REMOVE_FILE:
      return {
        ...state,
        file: null,
      };
    // set video
    case CREATE_TASTING_VIDEO_CHECK:
      return {
        ...state,
        videoCheck: action.payload,
      };
    case CREATE_TASTING_SET_TITLE1:
      return {
        ...state,
        title1: action.payload,
      };
    case CREATE_TASTING_SET_TITLE2:
      return {
        ...state,
        title2: action.payload,
      };
    case CREATE_TASTING_SET_ID_VIDEOS:
      return {
        ...state,
        id_youtube: action.payload,
      };
    case CREATE_TASTING_SET_IMAGE:
      return {
        ...state,
        image: action.payload,
      };
    case CREATE_TASTING_REMOVE_IMAGE:
      return {
        ...state,
        image: null,
      };
    // set brochure
    case CREATE_TASTING_BROCHURE_CHECK:
      return {
        ...state,
        brochureCheck: action.payload,
      };
    case CREATE_TASTING_SET_BROCHURE:
      return {
        ...state,
        brochure: action.payload,
      };
    case CREATE_TASTING_REMOVE_BROCHURE:
      return {
        ...state,
        brochure: null,
      };
    case CREATE_TASTING_SET_IMAGEBROCHURE:
      return {
        ...state,
        imageBrochure: action.payload,
      };
    case CREATE_TASTING_REMOVE_IMAGEBROCHURE:
      return {
        ...state,
        imageBrochure: null,
      };
    case CREATE_TASTING_SET_TITLE1B:
      return {
        ...state,
        title1b: action.payload,
      };
    case CREATE_TASTING_SET_TITLE2B:
      return {
        ...state,
        title2b: action.payload,
      };
    case "RESET_VIDEOS":
      return {
        ...state,
        videos: [],
      };
    case CREATE_TASTING_RESET:
      return {
        ...state,
        selectLang: null,
        types: ["tourism", "special", "event"],
        selectType: null,
        code: "",
        details: "",
        visit: "",
        store: "",
        file: null,

        brochure: null,
        brochureCheck: false,
        imageBrochure: null,
        title1b: "",
        title2b: "",

        title1: "",
        title2: "",
        image: null,
        videoCheck: false,
        id_youtube: "",
      };
    case ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
